import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { CpWeCallRequestModel } from '../../helpers/objects/request/we-call/cp-we-call-request-model';
import { map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CpAccountService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(@Inject(APP_CONFIG) appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  private getDecodedContract(): string | null {
    const raw = sessionStorage.getItem('contract');
    if (!raw) return null;
    try {
      return atob(raw);
    } catch {
      return null;
    }
  }

  weCall(body: CpWeCallRequestModel) {
    const contract = this.getDecodedContract();
    if (!contract) {
      return throwError(() => new Error('Missing contract in sessionStorage'));
    }

    const url = `${this.appConfig.api}contracts/${encodeURIComponent(contract)}/callback`;
    return this.http.post(url, body);
  }

  fhvcHandoff(): Observable<string | undefined> {
    const contract = this.getDecodedContract();
    if (!contract) {
      return throwError(() => new Error('Missing contract in sessionStorage'));
    }

    const url = `${this.appConfig.api}login/handoff/${encodeURIComponent(contract)}`;
    return this.http.get<any>(url).pipe(
      map((response) => response?.body?.intermediateToken as string | undefined)
    );
  }

  deactivateAccount() {
    return this.http.post(this.appConfig.api + '/delete-account',null);
  }
}
